<template>
  <div>
    <Wysiwyg>
      {{ error.message }}
    </Wysiwyg>
    <div style="display: flex; justify-content: center;">
      <Button style="margin-top: 1rem;" type="primary" @click="$router.push(`/${$route.params.country}/${$route.params.language}`)">
        Zurück
      </Button>
    </div>
    <div
      v-if="!prod"
      class="container"
    >
      <pre>{{ error }}</pre>
    </div>
  </div>
</template>

<script>
import Wysiwyg from 'beisheim/components/elements/wysiwyg'
import Button from 'beisheim/components/elements/button'

export default {
  components: {
    Button,
    Wysiwyg
  },
  props: {
    error: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    prod () {
      return process.env.NODE_ENV === 'production'
    }
  }
}
</script>
